import { render } from "./ReportReviewWorkspace.vue?vue&type=template&id=12560cae&scoped=true"
import script from "./ReportReviewWorkspace.vue?vue&type=script&lang=js"
export * from "./ReportReviewWorkspace.vue?vue&type=script&lang=js"

import "./ReportReviewWorkspace.vue?vue&type=style&index=0&id=12560cae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12560cae"]])

export default __exports__